import getShortDay from './globalGetShortDay';
import getStation from './globalGetStation';
import isCurrent from './globalIsCurrentProgram';
import getProgramProgress from './globalGetProgress';
import getProgramDuration from './globalGetDuration';
import getDate from './globalGetDate';

export default {
    methods: {
        mapProgramBlockItem(item) {
            return {
                id: item._id,
                title: item.title,
                lead: item.program && item.program.description,
                url: item.url,
                day: this.getShortDay(item.date_start),
                hour: this.getDate(item.date_start, '$h:$m'),
                duration: item.duration,
                isTimeline: this.isCurrent(item.date_start, item.date_end),
                progress: this.getProgramProgress(
                    item.date_start,
                    item.date_end
                ),
                start: item.date_start,
                end: item.date_end,
                isLive: item.live,
                station: item.station_logo_code
                    ? this.setStation(item.station_logo_code)
                    : null,
                station_code: item.station_logo_code,
                typeName:
                    item.program && item.program.type,
                image: 
                    item.program && item.program.image
            };
        }
    },
    mixins: [
        getStation,
        getDate,
        getProgramDuration,
        getProgramProgress,
        isCurrent,
        getShortDay
    ]
};
